'use strict';
const locked = document.getElementById('locked-content');
const unlocked = document.getElementById('unlocked-content');
const card = document.querySelector('.present-card');
const unlockButton = document.getElementById('unlock');
const unlockLabel = document.getElementById('unlock-label');
const unlockAt = Date.now() + 30000;
function updateCountdown() {
  const remaining = Math.max(0, Math.ceil((unlockAt - Date.now()) / 1000));
  unlockButton.disabled = remaining > 0;
  unlockLabel.textContent = remaining > 0 ? `Unlock in ${remaining}s` : 'Unlock my present';
  if (remaining === 0) clearInterval(countdown);
}
const countdown = setInterval(updateCountdown, 250);
updateCountdown();

function showGift(open, focus = true) {
  locked.hidden = open;
  unlocked.hidden = !open;
  card.setAttribute('aria-labelledby', open ? 'unlocked-title' : 'present-title');
  unlocked.classList.toggle('revealed', open);
  document.getElementById('copy-message').textContent = '';
  try { sessionStorage.setItem('babydolls-gift-open', String(open)); } catch {}
  if (focus) document.getElementById(open ? 'unlocked-title' : 'unlock').focus({preventScroll:true});
}
unlockButton.addEventListener('click', () => {
  if (Date.now() >= unlockAt) showGift(true);
});
document.getElementById('reset').addEventListener('click', () => showGift(false));
document.getElementById('copy').addEventListener('click', async () => {
  const message = document.getElementById('copy-message');
  try {
    await navigator.clipboard.writeText(document.getElementById('code').textContent);
    message.textContent = 'Code copied.';
  } catch {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(document.getElementById('code'));
    selection.removeAllRanges(); selection.addRange(range);
    message.textContent = 'Select and copy THANKYOU10 to save your code.';
  }
});
// Every page load begins locked, including after a previous reveal.
showGift(false, false);
